<template>
  <table class="mt-2 w-100">
    <tr v-if="serviceData.embriodery_id">
      <td><small>{{ $t('service.dstNumber') }}</small></td>
      <td><small>{{ serviceData.dst_number }}</small></td>
    </tr>
    <tr v-if="serviceData.embriodery_id">
      <td><small>{{ $t('service.machines') }}</small></td>
      <td><small>{{ serviceData.machines }}</small></td>
    </tr>
    <tr v-if="serviceData.embriodery_id">
      <td><small>{{ $t('service.stitchNumber') }}</small></td>
      <td><small>{{ serviceData.stitch_number }}</small></td>
    </tr>
    <tr v-if="serviceData.embriodery_id">
      <td><small>{{ $t('service.strandColors') }}</small></td>
      <td><small>{{ serviceData.strand_colors }}</small></td>
    </tr>
    <tr v-if="serviceData.serviceData.uses_embroidery">
      <td class="align-middle px-1">
        <small>{{ $t('service.embroidery.type') }}:</small>
      </td>
      <td>
        <div v-if="(readOnly || serviceData.service_package_id) || (serviceData.embroidery_type_name && !editEmbroideryType)">
          <small v-if="serviceData.embroidery_type_name">
            {{ serviceData.embroidery_type_name }}
            <a
              v-if="serviceData.embroidery_type_name && !readOnly && !serviceData.service_package_id"
              href="#"
              @click.prevent="editEmbroideryType = true;">
              <i class="material-icons">edit</i>
            </a>
          </small>
          <small v-else>
            &mdash;
          </small>
        </div>
        <div
          v-else
          class="form-control is-select">
          <v-select
            :options="embroideryTypes"
            v-model="serviceData.embroidery_type_id"
            @input="updateEmbroideryTypeName()"
            :placeholder="$t('service.chooseEmbroideryType')"
            :reduce="embroideryType => embroideryType.id"
            :searchable="false"
            label="name">
          </v-select>
        </div>
      </td>
    </tr>
    <tr>
      <td class="align-middle px-1">
        <small>{{ $t('service.embroidery.position') }}:</small>
      </td>
      <td>
        <div v-if="readOnly || (serviceData.embroidery_position_name && !editEmbroideryPosition)">
          <small v-if="serviceData.embroidery_position_name">
            {{ serviceData.embroidery_position_name }}
            <a
              v-if="serviceData.embroidery_position_name && !readOnly"
              href="#"
              @click.prevent="editEmbroideryPosition = true;">
              <i class="material-icons">edit</i>
            </a>
          </small>
          <small v-else>
            &mdash;
          </small>
        </div>
        <div
          v-else
          class="form-control is-select">
          <v-select
            :options="embroideryPositions"
            v-model="serviceData.embroidery_position_id"
            @input="updateEmbroideryPositionName()"
            :placeholder="$t('service.chooseEmbroideryPosition')"
            :reduce="embroideryPosition => embroideryPosition.id"
            :searchable="false"
            label="name">
          </v-select>
        </div>
      </td>
    </tr>
    <tr>
      <td class="align-middle px-1">
        <small>{{ $t('service.embroidery.size') }}:</small>
      </td>
      <td>
        <div v-if="readOnly">
          <small v-if="serviceData.embroidery_width">
            {{ serviceData.embroidery_width }}
          </small>
          <template v-if="serviceData.embroidery_width && serviceData.embroidery_height">
            <span class="px-1">&times;</span>
          </template>
          <small v-if="serviceData.embroidery_height">
            {{ serviceData.embroidery_height }}
          </small>
        </div>
        <div
          v-else
          class="d-flex align-middle">
          <d-input-group class="mr-1">
            <d-input
              size="sm"
              v-model="serviceData.embroidery_width"
              class="text-right" />
            <d-input-group-text slot="append">
              {{ $t('service.embroidery.width') }}
            </d-input-group-text>
          </d-input-group>
          <d-input-group>
            <d-input
              size="sm"
              v-model="serviceData.embroidery_height"
              class="text-right" />
            <d-input-group-text slot="append">
              {{ $t('service.embroidery.height') }}
            </d-input-group-text>
          </d-input-group>
        </div>
      </td>
    </tr>
    <tr>
      <td class="align-middle px-1">
        <small>{{ $t('service.embroidery.colors') }}:</small>
      </td>
      <td>
        <div v-if="readOnly">
          <small v-if="serviceData.embroidery_color">
            {{ serviceData.embroidery_color }}
          </small>
          <small v-else>
            &mdash;
          </small>
        </div>
        <d-input
          v-else
          size="sm"
          v-model="serviceData.embroidery_color" />
      </td>
    </tr>
  </table>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'order-creator-service-embroidery-config',
  props: [
    'embroideryItems',
    'readOnly',
    'serviceData'
  ],
  computed: {
    isEmbroidery () {
      return this.serviceData.serviceData.type_id === 1;
    },
    embroideryPositions () {
      let langToUse = this.$store.getters.getUserLang;

      return this.embroideryItems.positions.map(item => {
        let availableTranslation = item.translations.filter(translation => translation.language_id === langToUse);
        let itemName = item.name;

        if (availableTranslation.length) {
          itemName = availableTranslation[0].name;
        }

        return {
          id: item.id,
          name: itemName
        };
      });
    },
    embroideryTypes () {
      let langToUse = this.$store.getters.getUserLang;

      return this.embroideryItems.types.map(item => {
        let availableTranslation = item.translations.filter(translation => translation.language_id === langToUse);
        let itemName = item.name;

        if (availableTranslation.length) {
          itemName = availableTranslation[0].name;
        }

        return {
          id: item.id,
          name: itemName
        };
      });
    }
  },
  data () {
    return {
      editEmbroideryType: false,
      editEmbroideryPosition: false
    };
  },
  methods: {
    updateEmbroideryPositionName () {
      Vue.nextTick(() => {
        let positionID = this.serviceData.embroidery_position_id;

        if (positionID) {
          let positionName = this.embroideryItems.positions.filter(item => item.id === positionID);

          if (positionName && positionName[0]) {
            Vue.set(this.serviceData, 'embroidery_position_name', positionName[0].name);
          } else {
            Vue.set(this.serviceData, 'embroidery_position_name', 'UNKNOWN ID - ' + positionID);
          }
        } else if (positionID === null) {
          Vue.set(this.serviceData, 'embroidery_position_name', '');
        }
      });
    },
    updateEmbroideryTypeName () {
      Vue.nextTick(() => {
        let typeID = this.serviceData.embroidery_type_id;

        if (typeID) {
          let typeName = this.embroideryItems.types.filter(item => item.id === typeID);

          if (typeName && typeName[0]) {
            Vue.set(this.serviceData, 'embroidery_type_name', typeName[0].name);
          } else {
            Vue.set(this.serviceData, 'embroidery_type_name', 'UNKNOWN ID - ' + typeID);
          }
        } else if (typeID === null) {
          Vue.set(this.serviceData, 'embroidery_type_name', '');
        }
      });
    }
  }
}
</script>
